<template>
  <div class="login-container">
    <div class="left-box">
      <img src="@/assets/imgs/login-bg.png" alt="" class="img" />
    </div>

    <div class="right-box">
      <div class="right-box1">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <!-- <el-tab-pane
            label="账户密码登录"
            name="first"
          > <el-input
              placeholder="Email"
              suffix-icon="el-icon-user"
              v-model="passWrodObj.phone"
            >
            </el-input>
            <el-input
              placeholder="请输入密码"
              suffix-icon="el-icon-lock"
              v-model="passWrodObj.password"
              show-password
            ></el-input>
            <el-button
              class="anniu"
              type="primary"
            >立即登录</el-button>
          </el-tab-pane> -->
          <el-tab-pane label="手机号登录" name="second">
            <el-input
              v-model="codeObj.phoneNumber"
              placeholder="手机号"
            ></el-input>
            <div class="code">
              <el-input
                class="code-inp"
                v-model="codeObj.verifyCode"
                placeholder="请输入验证码"
              ></el-input>
              <el-button class="send-btn" @click="gettingdata" type="primary">{{
                sendCode
              }}</el-button>
            </div>
            <el-button class="anniu" type="primary" @click="loginByCode"
              >立即登录</el-button
            >
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { getLoginCode, dragonLogin } from '@/api/login';
var wait = 60;
export default {
  data() {
    return {
      activeName: 'second',
      checked: true,
      input: '',
      sendCode: '发送验证码',
      codeObj: {
        phoneNumber: '',
        verifyCode: '',
      },
      passWrodObj: {
        phone: '',
        password: '',
      },
      input2: '',
    };
  },
  mounted() {},
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // 获取验证码
    gettingdata() {
      if (this.codeObj.phoneNumber == '') {
        this.$msg.error('请输入手机号');
        return;
      }
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.codeObj.phoneNumber)) {
        this.$msg.error('请输入正确的手机号');
        return;
      }
      // getLoginCode(this.codeObj.phoneNumber).then((res) => {
      //   console.log(res);
      //   if (res.code == 200) {
      //     this.$msg.success('发送成功！');
      //   }
      // });
      if (this.sendCode == '发送验证码') {
        //按钮倒计时
        let _this = this;
        _this.sendCode = '发送中..';

        getLoginCode(this.codeObj.phoneNumber)
          .then((res) => {
            if (res.code == 200) {
              let timeOut = setInterval(function () {
                if (wait == 0) {
                  _this.sendCode = '发送验证码';
                  wait = 60;
                  clearInterval(timeOut);
                } else {
                  _this.sendCode = wait + '秒重新获取';
                  wait--;
                  // }
                }
              }, 1000);
            } else {
              _this.$msg.error('发送失败，请刷新后重试！');
              _this.sendCode = '发送验证码';
            }
          })
          .catch(() => {
            _this.$msg.error('发送失败，请刷新后重试！');
            _this.sendCode = '发送验证码';
          });
      }
    },
    loginByCode() {
      if (!this.codeObj.phoneNumber || !this.codeObj.verifyCode) {
        this.$msg.error('请输入手机号或验证码');
        return;
      }
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.codeObj.phoneNumber)) {
        this.$msg.error('请输入正确的手机号');
        return;
      }

      dragonLogin(this.codeObj).then((res) => {
        if (res.code == 200) {
          localStorage.setItem('token', res.data.token);
          this.$router.push('/');
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.code-inp {
  width: 121px;
}
</style>
